import { flagFactory } from '../icon';
import Svg from './nl.svg';

export default flagFactory(Svg);
